<header class="top-header">
  <nav class="navbar navbar-expand gap-3">
    <div class="container">
      <div class="mobile-toggle-icon fs-3">
        <i class="bi bi-list"></i>
      </div>
      <div class="row me-auto">
        <div class="col-md-auto header-size" *ngFor="let token of tokens">
          <label>{{instruments[token].display_name}}</label>
          <span class="form-control">{{instruments[token].price}}</span>
        </div>
      </div>
      <div class="top-navbar-right">
        <ul class="navbar-nav align-items-center">
          <li class="nav-item search-toggle-icon">
            <a class="nav-link" href="#">
              <div class="">
                <i class="bi bi-search"></i>
              </div>
            </a>
          </li>
          <li class="nav-item dropdown dropdown-user-setting">
            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              <div class="user-setting d-flex align-items-center">
                <img src="assets/images/avatars/avatar-1.png" class="user-img" alt="">
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" href="#">
                  <div class="d-flex align-items-center">
                    <img src="assets/images/avatars/avatar-1.png" alt="" class="rounded-circle" width="54" height="54">
                    <div class="ms-3">
                      <h6 class="mb-0 dropdown-user-name">{{username}}</h6>
                      <small class="mb-0 dropdown-user-designation text-secondary">Welcome</small>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item" (click)="logout()">
                  <div class="d-flex align-items-center">
                    <div class=""><i class="bi bi-lock-fill"></i></div>
                    <div class="ms-3"><span>Logout</span></div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<div id="logoutConfirmationModal" class="modal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">ALERT</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure want to logout?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onModalClose()">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="confirmLogout()">Logout</button>
      </div>
    </div>
  </div>
</div>
